module.exports = __webpack_public_path__ + "img/speedy-loans-logo.da3b1a88.png";